import UpslidingText from "components/Upsliding-Text";
import { motion } from "framer-motion";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as MoonIcon } from "assets/moon-icon.svg";
import { ReactComponent as SunIcon } from "assets/sun-icon.svg";
import LightLogo from "assets/light-logo.png";
import DarkLogo from "assets/dark-logo.png";
import "./style.css";
const Header = ({ darkMode = null, darkToggle = () => {} }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <nav
      className={`w-screen p-6 md:p-8 fixed top-0 left-0 ${
        darkMode ? "dark-app-navbar" : "app-navbar"
      }`}
    >
      <motion.div
        initial={{ y: "-100vh" }}
        animate={openMenu ? { y: "0" } : { y: "-100vh" }}
        transition={{ delay: 0.125, duration: 0.5 }}
        className='w-screen h-screen fixed top-0 left-0 bg-light dark:bg-dark z-[-1] pt-[92px] text-center'
      >
        <div className='flex flex-col p-16 justify-center gap-12 items-center'>
          <p
            className={` font-semibold text-dark dark:text-light opacity-50 ${
              location.pathname === "/" ? `opacity-100 ` : ``
            } w-[fit-content]`}
            onClick={(e) => {
              if (location.pathname !== "/") {
                window.scrollTo(0, 0);
                navigate("/");
              }
              setOpenMenu(false);
            }}
          >
            <UpslidingText
              text='Home'
              textCenter
              textSize='text-7xl'
              maxHeight='max-h-[70px]'
              color={"text-dark dark:text-light"}
            />
          </p>
          <p
            className={` font-semibold text-dark dark:text-light opacity-50 ${
              location.pathname === "/about" ? `opacity-100` : ``
            } w-[fit-content]`}
            onClick={(e) => {
              if (location.pathname !== "/about") {
                window.scrollTo(0, 0);
                navigate("/about");
              }
              setOpenMenu(false);
            }}
          >
            <UpslidingText
              text='About'
              textCenter
              textSize='text-7xl'
              maxHeight='max-h-[70px]'
              color={"text-dark dark:text-light"}
            />
          </p>
          <p
            className={` font-semibold text-dark dark:text-light opacity-50 ${
              location.pathname === "/work" ? `opacity-100` : ``
            } w-[fit-content]`}
            onClick={(e) => {
              if (location.pathname !== "/work") {
                window.scrollTo(0, 0);
                navigate("/work");
              }
              setOpenMenu(false);
            }}
          >
            <UpslidingText
              text='Work'
              textCenter
              textSize='text-7xl'
              maxHeight='max-h-[70px]'
              color={"text-dark dark:text-light"}
            />
          </p>
          <hr className='mt-24 border-2 border-dark dark:border-light w-full' />
        </div>
      </motion.div>
      <ul className='md:container md:mx-auto flex justify-between items-center'>
        <li>
          <img
            className='text-dark dark:text-light font-medium text-lg w-[50px] h-[40px] object-contain '
            alt='logo'
            onClick={(e) => {
              window.scrollTo(0, 0);
              navigate("/");
              setOpenMenu(false);
            }}
            src={darkMode ? DarkLogo : LightLogo}
          />
          {/* <SignIcon width={"250px"} /> */}
        </li>
        <li
          className='pl-[8px]'
          onClick={(e) => {
            setOpenMenu(!openMenu);
          }}
        >
          <div className='relative w-10 h-6 p-2'>
            <div
              className={`bg-dark dark:bg-light absolute menu-cross-left ${
                !openMenu ? `active` : ``
              }`}
              onClick={(e) => {
                setOpenMenu(!openMenu);
              }}
            ></div>
            <div
              className={`bg-dark dark:bg-light absolute menu-cross-right ${
                !openMenu ? `active` : ``
              }`}
              onClick={(e) => {
                setOpenMenu(!openMenu);
              }}
            ></div>
          </div>
        </li>
        <li>
          <p
            className='text-dark dark:text-light font-medium text-lg '
            onClick={() => {
              darkToggle();
            }}
          >
            <motion.button
              initial={{ scale: 1 }}
              whileHover={{ scale: 0.9 }}
              className='bg-dark dark:bg-light p-[4px] dark:p-[6px] rounded-full'
            >
              {!darkMode ? (
                <MoonIcon
                  width={"24px"}
                  height={"24px"}
                  className={"fill-light"}
                />
              ) : (
                <SunIcon width={"20px"} height={"20px"} />
              )}
            </motion.button>
          </p>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
